var api = require("!../../../../../../../../.nvm/versions/node/v12.22.12/lib/node_modules/expo-cli/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../../.nvm/versions/node/v12.22.12/lib/node_modules/expo-cli/node_modules/css-loader/dist/cjs.js!./Dropdown.style.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};